import moment from "moment";

function submissionTime(claim) {
  const value = claim.UpdatedDate;
  if (!value) return Infinity;
  const date = moment(value, [
    moment.ISO_8601,
    "YYYY-MM-DD HH:mm:ss.SSS",
    "YYYY-MM-DD HH:mm:ss",
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "D MMM YYYY",
    "DD-MMM-YYYY"
  ], "en", true);
  return date.isValid() && date.year() > 1 ? date.valueOf() : Infinity;
}

// Earliest EMI month of the claim (EMIDates may be a comma separated list).
function emiMonthTime(claim) {
  const raw = claim.EMIDates;
  if (!raw) return Infinity;
  const times = String(raw).split(",")
    .map(part => new Date(part.trim()).getTime())
    .filter(time => !isNaN(time));
  return times.length ? Math.min(...times) : Infinity;
}

function compareNumbers(first, second) {
  return first === second ? 0 : first < second ? -1 : 1;
}

export function compareClaimSubmission(a, b, key = "UpdatedDate") {
  if (key === "EMIDates") return compareNumbers(emiMonthTime(a), emiMonthTime(b));
  if (key !== "UpdatedDate") return null;
  // Claims submitted together share one UpdatedDate; list those by EMI month.
  return compareNumbers(submissionTime(a), submissionTime(b)) ||
    compareNumbers(emiMonthTime(a), emiMonthTime(b));
}

export function sortClaimsFifo(claims) {
  return claims.slice().sort((a, b) => compareClaimSubmission(a, b));
}



// WEBPACK FOOTER //
// ./src/services/claimOrder.js